import http from "~/common/http";

export const  PermissionModel = {
    id: 0,
    name: "",
    module: "",
    route: "",
    memo: "",
};

export const PermissionService = {

    /**
     * 创建角色
     * @param permission
     * @returns {*}
     */
    create(permission) {
        return http.post('/api/rbac/permissions/create', permission);
    },

    /**
     * 编辑角色信息
     * @param permission
     * @returns {IDBRequest | Promise<void>}
     */
    update(permission) {
        return http.put('/api/rbac/permissions/update?id=' + permission.id, permission);
    },

    /**
     * 删除角色信息
     * @param permissionId
     * @returns {*}
     */
    delete(permissionId) {
        return http.delete('/api/rbac/permissions/delete?id=' + permissionId);
    },

    /**
     * 得到角色信息
     * @param permissionId
     * @returns {*}
     */
    getpermissionInfo(permissionId) {
        return http.get('/api/rbac/permissions/view', {
            params: {id: permissionId}
        })
    },

    /**
     * 得到权限模块列表
     * @returns {*}
     */
    getModules() {
        return http.get('/api/rbac/permissions/modules');
    },

    /**
     * 得到权限列表
     * @param params
     * @returns {*}
     */
    getList(params) {
        return http.get('/api/rbac/permissions/index', {params: params});
    },

    /**
     * 得到授权操作项列表
     * @returns {*}
     */
    getOptions() {
        return http.get('/api/rbac/permissions/options');
    }
}


// WEBPACK FOOTER //
// ./src/services/Permission.js